// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const HamburgerIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M3 5h18a1 1 0 011 1 1 1 0 01-1 1H3a1 1 0 01-1-1 1 1 0 011-1zm0 6h18a1 1 0 011 1 1 1 0 01-1 1H3a1 1 0 01-1-1 1 1 0 011-1zm0 6h18a1 1 0 011 1 1 1 0 01-1 1H3a1 1 0 01-1-1 1 1 0 011-1z"/></svg>'} />;

HamburgerIcon.displayName = 'HamburgerIcon';

export default HamburgerIcon;
